<a class="btn btn-n1" (click)="clickLink()" [title]="target" [target]="target">
  <span>{{(label) ? label: 'llamada_ctc' | transloco}}</span>
  <neo-icono
    [iconoClase]="iconoClase"
  ></neo-icono>
</a>


<neo-main-acciones-dialogo-cta
[tituloDialog]="'llamada_ctc' | transloco"
[label]="(label) ? label: 'llamada_ctc' | transloco"
[descripcionDialog]="'llamada_ctc_txt' | transloco"
[tfnoCta1]="'123 456 789'"
[tfnoCta2]="'987 654 321'"
[mailCta]="'email@contacto.com'">
</neo-main-acciones-dialogo-cta>

<neo-proximamente-dlg [tituloDialog]="'proximamente_dlg_tit' | transloco"
  [descripcionDialog]="'proximamente_dlg_txt' | transloco">
</neo-proximamente-dlg>